export default __webpack_public_path__ + "static/media/bnb.ddefc4ca.png";